import React from 'react';
import format from 'date-fns/format';

type LastUpdateProps = {
    date: string
}

const formatDate = (date : string) : string => {
    const original = Date.parse(date);
    return format(original, 'MMMM d, y');
};

export const LastUpdate = ({ date } : LastUpdateProps) => (
    <div className="impact-numbers-stats-footer">
        <div className="footer-caption">
            <h2>Date last updated:</h2>
            <span className="date">{formatDate(date)}</span>
        </div>
    </div>
);
